import TemplateBuilderHelper from "./TemplateBuilderHelper";
import moduleAreas from "../constants/moduleAreaConstants";
import type { RiskAssessmentAiAssessmentDTO } from "../types/riskAssessmentAiDtos";

/**
 * Turns a generated assessment into the same template payload the builder posts, so
 * the AI flow reuses TemplateService.AddAsync rather than needing its own endpoint.
 * Every hazard becomes a custom hazard: they are specific to the client's work, and
 * the library only holds generic ones.
 */
export function buildAiTemplatePayload(
    assessment: RiskAssessmentAiAssessmentDTO,
    {
        conversationId,
        siteExternalId,
        allPeople,
    }: { conversationId: number | null; siteExternalId: string | null; allPeople: any[] }
) {
    const customHazards = (assessment.hazards ?? []).map((hazard) => ({
        name: hazard.name,
        siteExternalId,
        controls: [...(hazard.controlsInPlace ?? []), ...(hazard.additionalControls ?? [])],
    }));

    // The assistant picks from the people library by name, so match rather than invent.
    const peopleIds = (assessment.peopleAtRisk ?? [])
        .map((name) => allPeople?.find((p) => p.name?.toLowerCase() === name?.trim().toLowerCase())?.id)
        .filter((id) => id != null);

    const payload: any = new TemplateBuilderHelper(
        assessment.title,
        moduleAreas.RISKASSESSMENTS,
        assessment.description,
        undefined,
        undefined,
        undefined,
        undefined
    )
        .withHazardIds([])
        .withPeopleIds(peopleIds)
        .withRiskAssessmentSections([], [], customHazards)
        .withCustomHazards(customHazards)
        .build();

    payload.riskAssessmentAiConversationId = conversationId;

    // The API rejects a client template with no site, and a WorkNest one that has a
    // site, so the caller decides and passes null for a WorkNest user.
    if (siteExternalId) payload.siteExternalId = siteExternalId;

    return payload;
}
